module.exports = __webpack_public_path__ + "media/images/support/geolocation/geolocation-firefox-permission-2a-25fe0fed1642d086f38dfd0d5d7872ee.png";